<template>
    <div>
        <section v-if="article == null" aria-labelledby="news" id="news" class="panel panel--content panel--tight panel--listing panel--news" :class="'panel--'+background">
            <div class="panel__body">
                <div class="filter">
                    <h2 v-if="title" class="filter__title filter__title--inline">{{ title }}</h2>
                    <div v-if="news_dropdown == 1 && categories_array.length > 0" class="filter__categories filter__categories--inline filter__categories--left filter__categories--loadmore" style="padding-top:0;">
                        <div class="filter__select filter__select_news">
                            <label for="school-news-category" class="sr-only">News category</label>
                            <select id="school-news-category" class="custom-select form-control" aria-label="categories" v-model="selected_category">
                                <option v-for="category in categories_array" :value="category.value" :key="category.value" >
                                    {{ category.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <p v-if="posts == null || filtered_posts.length == 0">There are no news articles to display</p>
                <div v-if="filtered_posts.length > 0" class="content content--card ajax_posts" aria-live="polite">
                    <template v-for="post in filtered_posts">
                        <card 
                            :key="post.id" 
                            :image_url="post.thumbnail_image" 
                            :title="post.title" 
                            :date="post.date" 
                            :url="post.post_url" 
                            :hide_date="hide_date">
                        </card>
                    </template>
                </div>
                <div v-show="disable_show_more == false && posts_on_display < posts_total" class="show-more">
                    <button @click="show_more_posts" type="button" class="button show-more__button loadmore-btn">
                        Show more {{ button_label }}
                    </button>
                </div>
            </div>
        </section>
        <post v-if="article !== null" 
            :key="article.id" 
            :post_type="type" 
            :breadcrumbs="breadcrumbs_dom" 
            :article="article[0]" 
            :url="article_url" 
            :social_share="social_share_links">
        </post>
    </div>
</template>

<script>
import Card from './card.vue'
import Post from './post.vue'
import mixins from '../mixins.js'

export default {
    components: {
        'card': Card,
        'post': Post
    },
    props: {
        panel_number: Number,
        type: String,
        article_id: Number,
        background: String,
        title: String,
        posts: Array,
        item_count: Number,
        disable_show_more: Boolean,
        button_label: String,
        news_dropdown: Number,
        category_preset: String,
        fallback_thumbnail: String,
        hide_date: Boolean,
        social_share_links: Boolean
    },
    mixins: [ mixins ],
    data() {
        return {
            temp_data: null,
            filtered_posts: [],
            posts_total: 0,
            posts_on_display: 0,
            breadcrumbs_dom: null,
            article: null,
            article_url: '',
            categories_array: [],
            selected_category: '',
        }
    },
    watch: {
        selected_category() {
            // If we switched category we need to reset the posts_on_display value
            this.posts_on_display = parseInt(this.item_count); 
            // Now check to see if the all news category is used, if not loop all posts
            this.filter_posts(false);
        }
    },
    methods: {   
        add_canonical_meta_tag() {
            // Add in the posts canonical link in the header
            let link = document.createElement('link');
            link.rel = 'canonical';
            link.href = this.article[0].canonical_url;
            document.head.appendChild(link);
        },
        check_article_id() {
            // Check if 
            let id = this.article_id;
            // Is an article ID set?
            if(this.article_id > 0) {
                // Check and return a matching post
                this.article = this.filtered_posts.filter(function(post) {
                    return post.id == id;
                });
            }
            if(this.article_id > 0 && this.article.length !== 0) {
                // Found a matching article, so reconfigure the page you're on
                let host = window.location.host;
                this.article_url = host + this.article[0].post_url;
                this.remove_page_elements();
                this.add_canonical_meta_tag();
            } else {
                // Normal page
                this.unhide_page();
                // Only run the filter if we have posts
                if(this.posts !== null) {
                    // this.selected_category = 'all-news';
                    this.filter_posts(false);
                }
            }
        },
        extract_categories() {
            // Check to see if the category dropdown is set to true
            if(this.news_dropdown == 1){ 
                // Clear the array and loop through the filtered posts
                this.categories_array = [];
                for(let i=0; i < this.filtered_posts.length; i++){
                    // Loop through each category in that post
                    for(let j=0; j < this.filtered_posts[i].categories.length; j++){
                        // Now see if a matching object (by value/slug) exists
                        if(!this.categories_array.some(e => e.value === this.filtered_posts[i].categories[j].value)) {
                            // No match found, so push into the array our category
                            this.categories_array.push(this.filtered_posts[i].categories[j]);
                        }
                    }
                }
                // Sort the objects by the name value
                this.categories_array.sort(function(a, b){
                    if(a.name < b.name) { return -1; }
                    if(a.name > b.name) { return 1; }
                    return 0;
                })
                // Create an 'all news' object variable
                var all_items = { 
                    'name': "All news", 
                    'value': 'all-news'
                }
                // Now splice that into the first position on the array
                this.categories_array.splice(0, 0, all_items);
            }
        },
        filter_posts(show_more) {
            let temp_posts = [];

            if(this.temp_data == null) {
                return true;
            }

            // Now filter out posts
            if(this.selected_category == "all-news"){
                // Reinstates the filtered posts array
                this.filtered_posts = this.temp_data.slice(0, parseInt(this.item_count));
                if(show_more == true) {
                    this.posts_on_display = this.posts_on_display + parseInt(this.item_count);
                    this.filtered_posts = this.temp_data.slice(0, this.posts_on_display); 
                    this.posts_total = this.temp_data.length
                } else {
                    this.posts_on_display = parseInt(this.item_count);
                    this.filtered_posts = this.temp_data.slice(0, parseInt(this.item_count));
                    this.posts_total = this.temp_data.length
                }
            } else {
                // Now we need to loop through the posts
                for(let i = 0; i < this.temp_data.length; i++){
                    // Then the categories in those posts
                    for(let j = 0; j < this.temp_data[i].categories.length; j++){
                        // And see if they have a matching category based upon the value
                        if(this.selected_category == this.temp_data[i].categories[j].value){
                            temp_posts.push(this.temp_data[i]);
                        }
                    }
                }
                if(show_more == true) {
                    this.posts_on_display = this.posts_on_display + parseInt(this.item_count);
                    this.filtered_posts = temp_posts.slice(0, this.posts_on_display); 
                    this.posts_total = temp_posts.length
                } else {
                    this.posts_on_display = parseInt(this.item_count);
                    this.filtered_posts = temp_posts.slice(0, parseInt(this.item_count));
                    this.posts_total = temp_posts.length
                }
            }
        },
        hide_page() {
            // Hide other DOM elements
            var main_container = document.body;
			main_container.style.display = "none";
        },
        html_decode(string){
            var e = document.createElement('textarea');
            e.innerHTML = string;
            // Handle case of empty input
            return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
        },
        pretty_string(value) {
            // Removes hyphens and makes the first character uppercase
            var string = value.replace(/-/g,' ');
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        reformat_data() {
            // This runs once at the creation phase
            
            // If the call returns no posts
            if(this.posts == null) {           
                this.unhide_page();
                return true
            }

            let request_uri = location.pathname + location.search;
            let temp_posts = [];
            if(this.type == 'local_feed' || this.type == 'blogs_network_feed' ) {                
                temp_posts = this.posts;
            } else if(this.type == 'external_feed' || this.type == 'kent_ac_uk') {
                for(let i=0; i < this.posts.length; i++){
                    
                    // Define our variables
                    let thumbnail;
                    let caption;
                    let banner;
                    let post_link;
                    let author;
                    let author_url;
                    let post_categories = [];
                    let post_tags = [];

                    // Define our thumbnail and banner images
                    if(this.posts[i].featured_image.sizes && this.posts[i].featured_image.sizes !== undefined){
                        // The additional if statement below was added due to an issue with posts from kbs
                        // Some post objects had bad size objects and I couldn't check against that alone, had to also check against the medium. Odd but work for now
                        // URL - https://blogs.kent.ac.uk/kbs-news-events/
                        // Category - cequfin
                        if(this.posts[i].featured_image.sizes.large !== undefined) {
                            thumbnail = this.posts[i].featured_image.sizes.large.url;
                            banner = this.posts[i].featured_image.sizes.large.url;
                        } else if(this.posts[i].featured_image.sizes.medium !== undefined) {
                            thumbnail = this.posts[i].featured_image.sizes.medium.url;
                            banner = this.posts[i].featured_image.sizes.medium.url;
                        } else {
                            thumbnail = this.fallback_thumbnail;
                            banner = '';
                        }
                    } else if(this.posts[i].media.length > 0){
                        // Sometimes the featured image object is blank. If so use the media object instead
                        if(Object.keys(this.posts[i].media[0].sizes).length > 0) {
                            // Use the large image if available, else medium
                            if(this.posts[i].media[0].sizes.large !== undefined) {
                                thumbnail = this.posts[i].media[0].sizes.large.url;
                                banner = this.posts[i].media[0].sizes.large.url;
                            } else {
                                thumbnail = this.posts[i].media[0].sizes.medium.url;
                                banner = this.posts[i].media[0].sizes.medium.url;
                            }
                        } else {
                            thumbnail = this.fallback_thumbnail;
                            banner = '';
                        }
                    } else if(this.posts[i].inlineImage !== undefined) {
                        thumbnail = this.posts[i].inlineImage;
                        banner = this.posts[i].inlineImage;
                    } else {
                        thumbnail = this.fallback_thumbnail;
                        banner = '';
                    }

                    // Image caption
                    if(this.posts[i].featured_image.caption && this.posts[i].featured_image.caption.length > 0) {
                        caption = this.posts[i].featured_image.caption;
                    } else {
                        caption = '';
                    }

                    // Redefine the post URL depending if we are loading an article or not. This is relevant for social media links
                    // Without this it doubles up the ?article part of the URL
                    if(this.article_id > 0) {
                        post_link = request_uri
                    } else {
                        post_link = request_uri + '?article=' + this.posts[i].id
                    }

                    // Clean up the author name and user URL
                    if(this.posts[i].author){
                        if(this.posts[i].author.meta.first_name.length > 0){
                            author = this.posts[i].author.meta.first_name + ' ' + this.posts[i].author.meta.last_name;
                        } else {
                            author = this.posts[i].author.display_name;
                        }
                        author_url = this.posts[i].author.user_url;
                    } else {
                        author = null;
                        author_url = null;
                    }

                    // Rebuild our categories
                    if(Object.keys(this.posts[i].categories).length > 0){
                        for (let category in this.posts[i].categories){
                            let obj = {
                                name: this.pretty_string(this.posts[i].categories[category].name),
                                value: this.posts[i].categories[category].slug
                            }        
                            post_categories.push(obj);
                        }
                    }

                    // Rebuild our tags
                    if(Object.keys(this.posts[i].tags).length > 0){
                        for (let tag in this.posts[i].tags){
                            let obj = {
                                name: this.pretty_string(this.posts[i].tags[tag].name),
                                value: this.posts[i].tags[tag].slug
                            }        
                            post_tags.push(obj);
                        }
                    } 

                    // Now build our final post object
                    let obj = {
                        id: this.posts[i].id,
                        thumbnail_image: thumbnail,
                        image_caption: caption,
                        banner_image: banner,
                        title: this.html_decode(this.posts[i].title),
                        date: this.convert_date(this.posts[i].date),
                        post_url: post_link,
                        canonical_url: this.posts[i].permalink,
                        author_name: author,
                        author_url: author_url,
                        content: this.posts[i].content,
                        categories: post_categories,
                        tags: post_tags
                    }
                    temp_posts.push(obj);
                }
            }
            this.temp_data = temp_posts;
            this.filtered_posts = temp_posts;
            this.posts_total = this.filtered_posts.length
            this.extract_categories(); // This only needs to run the once also
        },
        remove_page_elements() {     
            // Get the breadcrumbs HTML and clone it
            if(document.getElementById("page-breadcrumb") !== null){
                var breadcrumbs = document.getElementById("page-breadcrumb");
                this.breadcrumbs_dom = breadcrumbs.innerHTML;
            }
            // Grab all children elements and make into an array
            var list_children = document.getElementById("main").children;
            var list_array = []
            for(var i = 0; i < list_children.length; i++){
                list_array.push(list_children[i]);
            }
            // Loop through the array and check for anything which isn't the main or article body and hide them
            for(i = 0; i < list_array.length; i++){
                if(!list_array[i].classList.contains('news_article')) {
                    list_array[i].parentNode.removeChild(list_array[i]);
                }
            }
            // Append the breadcrumbs to our template and show our page
            this.unhide_page();                
        },
        show_more_posts() {
            // Call our filter method, but specifying it is a show more call
            this.filter_posts(true);
        },
        unhide_page() {
            // Make the page visible once again
            var main_container = document.body;
            main_container.style.display = "block";
        },
    },
    created() {
        // If a category is preset, use it or set to all news
        if(this.category_preset !== null && this.category_preset.length > 0){
            let preset = this.category_preset.replace(/\s+/g, '-').toLowerCase();
            this.selected_category = preset
        } else {
            this.selected_category = 'all-news'
        }
        // Hide the page during processing and checking of the data / props
        this.hide_page();
        // Tidy up the data coming over from PHP
        this.reformat_data();
        // Set our base number of posts to show
        this.posts_on_display = parseInt(this.item_count);
        // Now check to see if it is a news panel page or an article post
        this.check_article_id();
    },
    beforeDestroy() {
        localStorage.removeItem('newsArray-' + this.panel_number);
    }
}
</script>
